export var RelationType;
(function (RelationType) {
    // Infrastructure and Hosting
    RelationType["RUNS_ON"] = "RUNS_ON";
    RelationType["DEPENDS_ON"] = "DEPENDS_ON";
    RelationType["HOSTED_BY"] = "HOSTED_BY";
    RelationType["USES_INFRASTRUCTURE"] = "USES_INFRASTRUCTURE";
    // Service relationships
    RelationType["PROVIDES_SERVICE"] = "PROVIDES_SERVICE";
    RelationType["CONSUMED_BY"] = "CONSUMED_BY";
    RelationType["PART_OF_SERVICE"] = "PART_OF_SERVICE";
    // Data and Storage
    RelationType["READS_FROM"] = "READS_FROM";
    RelationType["WRITES_TO"] = "WRITES_TO";
    RelationType["STORES_DATA_IN"] = "STORES_DATA_IN";
    RelationType["BACKED_UP_BY"] = "BACKED_UP_BY";
    RelationType["REPLICATES_TO"] = "REPLICATES_TO";
    // Network and Security
    RelationType["IN_ZONE"] = "IN_ZONE";
    RelationType["IN_SECURITY_ZONE"] = "IN_SECURITY_ZONE";
    RelationType["USES_NETWORK"] = "USES_NETWORK";
    RelationType["CONNECTS_TO"] = "CONNECTS_TO";
    RelationType["PROTECTED_BY"] = "PROTECTED_BY";
    RelationType["ISOLATED_FROM"] = "ISOLATED_FROM";
    RelationType["EXPOSES_SERVICE"] = "EXPOSES_SERVICE";
    // Authentication and Secrets
    RelationType["USES_SECRET"] = "USES_SECRET";
    RelationType["USES_CERTIFICATE"] = "USES_CERTIFICATE";
    RelationType["USES_CONFIG"] = "USES_CONFIG";
    RelationType["USES_IDP"] = "USES_IDP";
    RelationType["REQUIRES_AUTH"] = "REQUIRES_AUTH";
    RelationType["AUTHENTICATES_WITH"] = "AUTHENTICATES_WITH";
    RelationType["PROVIDES_AUTHENTICATION"] = "PROVIDES_AUTHENTICATION";
    // Monitoring and Operations
    RelationType["LOGS_TO"] = "LOGS_TO";
    RelationType["MONITORED_BY"] = "MONITORED_BY";
    RelationType["ALERTS_TO"] = "ALERTS_TO";
    // Ownership and Responsibility
    RelationType["OWNED_BY"] = "OWNED_BY";
    RelationType["MAINTAINED_BY"] = "MAINTAINED_BY";
    RelationType["RESPONSIBLE_FOR"] = "RESPONSIBLE_FOR";
    // Risk and Security
    RelationType["HAS_RISK"] = "HAS_RISK";
    RelationType["MITIGATED_BY"] = "MITIGATED_BY";
    RelationType["THREAT"] = "THREAT";
    RelationType["EXPLOITS"] = "EXPLOITS";
    RelationType["IMPLEMENTS_CONTROL"] = "IMPLEMENTS_CONTROL";
    RelationType["PROTECTS"] = "PROTECTS";
    RelationType["HAS_CONTROL_GAP"] = "HAS_CONTROL_GAP";
    RelationType["RESOLVED_BY"] = "RESOLVED_BY";
    // Documentation
    RelationType["DOCUMENTED_BY"] = "DOCUMENTED_BY";
    RelationType["FOLLOWS_PROCESS"] = "FOLLOWS_PROCESS";
    RelationType["HAS_PROCEDURE"] = "HAS_PROCEDURE";
    // Integration and Data Flow
    RelationType["SENDS_DATA_TO"] = "SENDS_DATA_TO";
    RelationType["RECEIVES_DATA_FROM"] = "RECEIVES_DATA_FROM";
    RelationType["PUBLISHES_EVENT"] = "PUBLISHES_EVENT";
    RelationType["SUBSCRIBES_TO"] = "SUBSCRIBES_TO";
    RelationType["CALLS_API"] = "CALLS_API";
    // Platform Relationships
    RelationType["PART_OF_PLATFORM"] = "PART_OF_PLATFORM";
    RelationType["USES_PLATFORM"] = "USES_PLATFORM";
    RelationType["DEPLOYED_ON"] = "DEPLOYED_ON";
    // DNS and Networking
    RelationType["RESOLVES_VIA"] = "RESOLVES_VIA";
    // CI/CD and Container Registry
    RelationType["DEPLOYS_TO"] = "DEPLOYS_TO";
    RelationType["PULLS_FROM"] = "PULLS_FROM";
    RelationType["PUSHES_TO"] = "PUSHES_TO";
})(RelationType || (RelationType = {}));
export var CriticalityLevel;
(function (CriticalityLevel) {
    CriticalityLevel["CRITICAL"] = "critical";
    CriticalityLevel["HIGH"] = "high";
    CriticalityLevel["MEDIUM"] = "medium";
    CriticalityLevel["LOW"] = "low";
})(CriticalityLevel || (CriticalityLevel = {}));
